import React, {FC} from 'react';
import {SetStatePropsType} from "@baseTypes/base";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import {MAP_LAYERS} from "../constants/layers";
import {useTranslation} from 'react-i18next';
import {sx} from './sx'
import MenuBarCustom from "@ui/menuBarCustom/MenuBarCustom";
import {useSearchParams} from 'react-router-dom';
import {getPrevSearchParams} from "@helpers/searchParams/helpers";
import MapLayerIcon from "@resource/svg/mapLayerIcon";
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";

interface IProps {
    url: string,
    setUrl: SetStatePropsType<string>
}

const SelectTitleLayer: FC<IProps> = ({
                                          url,
                                          setUrl,
                                      }) => {

    const {t} = useTranslation()


    const [_, setSearchParams] = useSearchParams()

    const list = Object.entries(MAP_LAYERS).map(([key, item]) => {
        return (
            <FormControlLabel
                key={key}
                value={key}
                control={<Radio/>}
                label={t(item.label)}
            />
        )
    })
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = (event.target as HTMLInputElement).value;
        setSearchParams((prev) => {
            return {
                ...getPrevSearchParams(prev),
                mapLayer: value
            }
        })
        setUrl(value);
    };

    return (
        <MenuBarCustom
            button={<IconButtonCustom
                sx={sx.btn}
                variant={'empty'}
            >
                <MapLayerIcon/>
            </IconButtonCustom>}
            sx={sx.root}
        >
            <FormControl>
                <FormLabel>{t('base.layer')}</FormLabel>
                <RadioGroup
                    value={url}
                    onChange={handleChange}
                >
                    {list}
                </RadioGroup>
            </FormControl>
        </MenuBarCustom>
    );
};

export default SelectTitleLayer;